import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

interface SEOHelmetProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
}

const SEOHelmet = ({ title, description, keywords, image, url }: SEOHelmetProps) => {
  const location = useLocation();
  const currentUrl = url || `https://quantmake.ai${location.pathname}`;
  
  // Default values
  const defaultTitle = "QuantMake.AI - Robô Trader Automatizado e Copy Trade Inteligente";
  const defaultDescription = "🚀 QuantMake.AI - Robôs trader automatizados e copy trade inteligente. Trading algorítmico no mercado futuro B3 com resultados reais comprovados. Especialistas CNPI.";
  const defaultKeywords = "robo trader, copy trade, trading automatizado, algoritmos trading, day trade, mercado futuro b3, quantmake";
  const defaultImage = "https://quantmake.ai/lovable-uploads/quantmake-logo-principal-robo-trader-automatizado.png";

  // Route-specific SEO data
  const getRouteSpecificData = () => {
    switch (location.pathname) {
      case '/duocore':
        return {
          title: title || "DUOCORE Copy Trade | Tecnologia Dual-Core QuantMake.AI | Trading Automatizado",
          description: description || "🚀 DUOCORE - Sistema revolucionário de copy trade com tecnologia dual-core. Processamento em 2 núcleos para máxima performance. Copy trade inteligente com margem R$ 20k no mercado futuro B3.",
          keywords: keywords || "DUOCORE copy trade, tecnologia dual-core trading, DUOCORE QuantMake, copy trade automatizado, trading dual-core, DUOCORE processamento, copy trade inteligente, DUOCORE algoritmos, trading margem 20k, DUOCORE B3",
          image: image || "https://quantmake.ai/lovable-uploads/quantmake-grafico-resultado-duocore-trading-automatizado.png"
        };
      case '/robos':
        return {
          title: title || "Robôs Trader Automatizados QuantMake.AI | Trading Algorítmico B3",
          description: description || "🚀 Robôs trader automatizados QuantMake.AI. Trading algorítmico no mercado futuro B3 com resultados comprovados. Especialistas CNPI, estratégias quantitativas avançadas.",
          keywords: keywords || "robos trader automatizados, trading algoritmico, robos quantmake, nelogica profit, autotrade, smartgrid, fibonacci trader, larry williams",
          image: image || "https://quantmake.ai/lovable-uploads/quantmake-logo-horizontal-robo-trader-copy-trade.png"
        };
      default:
        return {
          title: title || defaultTitle,
          description: description || defaultDescription,
          keywords: keywords || defaultKeywords,
          image: image || defaultImage
        };
    }
  };

  const seoData = getRouteSpecificData();

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{seoData.title}</title>
      <meta name="description" content={seoData.description} />
      <meta name="keywords" content={seoData.keywords} />
      <link rel="canonical" href={currentUrl} />

      {/* Open Graph */}
      <meta property="og:title" content={seoData.title} />
      <meta property="og:description" content={seoData.description} />
      <meta property="og:image" content={seoData.image} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="QuantMake.AI" />

      {/* Twitter Cards */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seoData.title} />
      <meta name="twitter:description" content={seoData.description} />
      <meta name="twitter:image" content={seoData.image} />

      {/* Additional SEO */}
      <meta name="robots" content="index, follow" />
      <meta name="author" content="QuantMake.AI" />
      <meta name="language" content="pt-BR" />
    </Helmet>
  );
};

export default SEOHelmet;